import { omitBy, isNil } from 'lodash';

const removeUndefinedKeyObj = (obj: object) => {
  return omitBy(obj, isNil);
}

export default removeUndefinedKeyObj;

